import {
  Backdrop,
  Box,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import { useState } from "react";
import { nanoid } from "nanoid";

const UserTable = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      {props?.getData?.length > 0 && (
        <Box sx={{ marginBottom: "20px" }}>
          <Typography
            variant="h6"
            sx={{ paddingX: "10px" }}
            className={globalClasses.typography}
          >
            Added Users
          </Typography>

          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#006699" }}>
                  <TableCell sx={{ color: "white", padding: "12px" }}>
                    Clinic Name
                  </TableCell>
                  <TableCell sx={{ color: "white", padding: "12px" }}>
                    Username
                  </TableCell>
                  <TableCell sx={{ color: "white", padding: "12px" }}>
                    Name
                  </TableCell>
                  <TableCell sx={{ color: "white", padding: "12px" }}>
                    Email
                  </TableCell>
                  <TableCell sx={{ color: "white", padding: "12px" }}>
                    Mobile Number
                  </TableCell>
                  <TableCell sx={{ color: "white", padding: "12px" }}>
                    Edit
                  </TableCell>
                  <TableCell sx={{ color: "white", padding: "12px" }}>
                    Delete
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props?.getData?.map((userDetail: any, index: any) => (
                  <TableRow key={nanoid()}>
                    <TableCell>{userDetail.clinicName}</TableCell>
                    <TableCell>{userDetail.userName}</TableCell>
                    <TableCell>
                      {" "}
                      {userDetail.givenName} {userDetail.familyName}
                    </TableCell>
                    <TableCell>{userDetail.userEmailId}</TableCell>
                    <TableCell>{userDetail.userMobile}</TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={(event: any) => {
                          setIsLoading(true);
                          setTimeout(() => {
                            props.setData(userDetail, index);
                            setIsLoading(false);
                          }, 500);
                        }}
                      >
                        <BorderColorIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <DeleteForeverOutlinedIcon
                        fontSize="large"
                        color="error"
                        onClick={(event: any) => {
                          props.deleteUser(event, index);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {isLoading && (
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: 1500,
                display: "flex",
                flexDirection: "column",
              }}
              open
            >
              <Typography fontWeight="600" fontSize="20px">
                Loading User Information...!
              </Typography>
              <CircularProgress color="primary" sx={{ margin: "20px" }} />
            </Backdrop>
          )}
        </Box>
      )}
    </>
  );
};

export default UserTable;
